import { render, staticRenderFns } from "./MiroIntegration.vue?vue&type=template&id=2d2f4180&scoped=true&"
import script from "./MiroIntegration.vue?vue&type=script&lang=js&"
export * from "./MiroIntegration.vue?vue&type=script&lang=js&"
import style0 from "./MiroIntegration.vue?vue&type=style&index=0&id=2d2f4180&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f4180",
  null
  
)

export default component.exports